import { type ReadinessItem, type Release } from "api/dashboardBackend";
import LinkPill from "components/common/LinkPill";
import styles from "components/release/preamble/Preamble.module.scss";
import UsefulLinks from "components/release/useful-links/UsefulLinks";
import { PlatformId } from "util/platform";

interface Props {
  dailyActiveUsers?: ReadinessItem;
  platformId: PlatformId;
  sizeMetrics?: ReadinessItem[];
  release: Release;
}

export const Preamble = ({
  dailyActiveUsers,
  platformId,
  sizeMetrics,
  release,
}: Props): JSX.Element | null => {
  const hasDau = dailyActiveUsers !== undefined;
  const hasSizeMetrics = sizeMetrics !== undefined && sizeMetrics.length > 0;
  const hasUsefulLinks =
    platformId.toLowerCase() === PlatformId.Android ||
    platformId.toLowerCase() === PlatformId.China;
  const hasPreamble = hasDau || hasSizeMetrics || hasUsefulLinks;

  if (!hasPreamble) {
    return null;
  }

  return (
    <div className={styles.preamble}>
      {dailyActiveUsers ? (
        <LinkPill
          formattedValue={dailyActiveUsers.formattedValue}
          label={dailyActiveUsers.label}
          url={dailyActiveUsers.url}
        />
      ) : null}
      {sizeMetrics
        ? sizeMetrics.map((sizeMetric, idx) => (
            <LinkPill
              formattedValue={sizeMetric.formattedValue}
              key={idx}
              label={sizeMetric.label}
              url={sizeMetric.url}
            />
          ))
        : null}
      <UsefulLinks platformId={platformId} release={release} />
      {platformId === PlatformId.China ? (
        <div className={styles.cliContainer}>
          CLI to download all APKs: aws s3 cp --recursive
          s3://duolingo-android-builds.internal.duolingo.com/release/China/
          {release.majorMinor}.{release.patch}.{release.build}/ .
        </div>
      ) : null}

      {platformId === PlatformId.IOS ? (
        <p style={{ fontSize: "0.75em" }}>
          (*) This download file size is the largest size that a
          &quot;non-universal&quot; device gets because the vast majority of our
          users don&apos;t get the universal app size. This number should
          ideally be below 200 MB because we will get a cellular data download
          warning above that.
        </p>
      ) : null}
    </div>
  );
};

export default Preamble;
